import { gql } from 'urql'

export const GET_COMPANY_BUSINESS_GROUPS = gql`
  query GetCompanyBusinessGroups {
    companyBusinessGroups {
      id
      name
      description
      companiesCount
      createdAt
      updatedAt
      createdBy
    }
  }
`

export const GET_COMPANY_BUSINESS_GROUP = gql`
  query GetCompanyBusinessGroup($id: String!) {
    companyBusinessGroup(id: $id) {
      id
      name
      description
      companiesCount
      createdAt
      updatedAt
      createdBy
      companies {
        id
        name
        rut
        alias
      }
    }
  }
`

export const CREATE_COMPANY_BUSINESS_GROUP = gql`
  mutation CreateCompanyBusinessGroup($input: CreateCompanyBusinessGroupInput!) {
    createCompanyBusinessGroup(input: $input) {
      id
      name
      description
      companiesCount
    }
  }
`

export const UPDATE_COMPANY_BUSINESS_GROUP = gql`
  mutation UpdateCompanyBusinessGroup($input: UpdateCompanyBusinessGroupInput!) {
    updateCompanyBusinessGroup(input: $input) {
      id
      name
      description
      companiesCount
      companies {
        id
        name
        rut
        alias
      }
    }
  }
`

export const DELETE_COMPANY_BUSINESS_GROUP = gql`
  mutation DeleteCompanyBusinessGroup($id: String!) {
    deleteCompanyBusinessGroup(id: $id)
  }
`

export const SET_COMPANY_BUSINESS_GROUP_MEMBERS = gql`
  mutation SetCompanyBusinessGroupMembers(
    $input: SetCompanyBusinessGroupMembersInput!
  ) {
    setCompanyBusinessGroupMembers(input: $input) {
      id
      name
      description
      companiesCount
      companies {
        id
        name
        rut
        alias
      }
    }
  }
`
